import { render, staticRenderFns } from "./WxBlank.vue?vue&type=template&id=28e3562e&scoped=true&"
import script from "./WxBlank.vue?vue&type=script&lang=js&"
export * from "./WxBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3562e",
  null
  
)

export default component.exports